const crud = { c: false, r: false, u: false, d: false };

export const profiles = Object.freeze({
  profile: { ...crud },
  password: { ...crud },
});
